import React, {FC} from "react";
import Divider from "../divider";
import Spacer from "../spacer";
import VidaSection from "../../../../components/@vida/vida-section";

const SoftwareDownload: FC = () => {
  return <div>
    <VidaSection title="" id="software-download">
      <Divider/>
      <h1>Software Download</h1>

      {/* Downloads, Workshop and Vehicle preparedness */}
      <Spacer/>
      <VidaSection title="Downloads, Workshop and Vehicle preparedness"
                   id="downloads-workshop-and-vehicle-preparedness">
        <p><strong>Software Downloads, Workshop and Vehicle Preparedness</strong></p>
        <p><strong>Volvo Vehicle Software is tested and installed successfully and is in used on the hundreds of
          thousands of Volvo Cars driving all over North America.</strong></p>
        <p><strong>It is important to understand there are many contributors to a successful software installation or
          failed software installation.</strong></p>
        <p>Below are some items for general discussion, which careful attention is necessary. Although cannot be limited
          to only these. Always follow VIDA information whenever possible.</p>
        <p>You may find this helpful in understanding the process when getting ready to download software.</p>
        <p>It is <strong>imperative</strong> the infrastructure of the workshop meet the minimum IT requirements (See
          Computer requirements) And important as well but not limited to internet speed, traffic on the network,
          firewalls etc.</p>
        <p>The state of preparedness of the Vehicle is equally critical. The vehicle must be in a state of preparedness
          enabling it to receive the software you wish to install.</p>
        <p>Prior to downloading software, the technician shall investigate and correct any failures where it is found
          necessary. For example, but not limited to what is indicated by (DTC’s) diagnostic trouble codes and checking
          all vehicle modules are communicating and online. Without making necessary corrections there is a risk of a
          software download failure. For example, but not limited to DTCs found in the CAN. Whether it is a high or low
          speed <em>Communication Area Network</em> problem it is critical its fault traced and resolved prior to
          downloading software. This is only one example.</p>
        <p>The car must be a North American Market Vehicle, otherwise the software sale will be blocked.</p>
        <p>Prior to and during downloading software, the car <strong>must be connected to a battery maintainer
          –</strong> over or under voltage can contribute to a software download failure.</p>
        <p>Parts must be for that car, errors in parts ordering will prevent software from being successfully
          Downloaded. Parts previously installed in another car and or programmed to another car should not be used in
          repairs.</p>
        <p>As cars age, Technicians or our customers working on their own car with the best intentions, can often
          without understanding can perform substandard repairs causing download failures.</p>
        <p>For example, but not limited to incorrect parts, they may be incompatible or previously programmed parts to
          another car, or parts installed without ever being programmed which can cause software installation issues
          when the next technician is working on the car. Sometimes this can be realized when the car comes in with
          warning lights illuminated in the driver display. Careful consideration to fault trace and repair these can be
          necessary - and when identified as necessary, they must be corrected prior to attempting any software
          download. Ignoring these and loading software regardless, is at your own risk.</p>
        <p>Pass through devices and cables and all connections must be in good working order.</p>
      </VidaSection>

      {/* Software Download Job Aid */}
      <Spacer/>
      <VidaSection title="Software Download Job Aid"
                   id="software-download-job-aid">
        <p><strong>SWDL Job Aid</strong></p>
        <p><strong>Software Download Best Practices for SPA and CMA</strong></p>
        <p><strong>This is a general guide with tips and tricks to help avoid SPA/CMA software download
          failures.</strong></p>
        <p style={{color: "red"}}>***Always consult VIDA and Tech Journals for the latest process***</p>
        <p>TJ 31543 is the current SWDL (Software Download) guide and should be consulted for process updates.</p>
        <p>When the vehicle is driven into the shop, check the installed map version, and take a picture of the
          installed apps with your phone or camera. This will help you see if there is a map update required and to get
          the customer’s apps get reinstalled. This will also show if the apps require an update.</p>
        <p>As you get out of the vehicle, set the light switch to the “Position” setting. This will help keep the car
          awake during the download.</p>
        <p>Leave the driver’s door propped open and open the tailgate/bootlid. These will help keep the car “awake”
          during the download. Opening the tailgate/bootlid will give easy access to the battery, should you need to
          perform a reset.</p>
        <p>Connect the maintainer (charger) at the charging posts under the hood. Use a meter (DVOM) to check that the
          maintainer has the correct voltage output (13V – 15V).</p>
        <p>Connect the vehicle to VIDA.</p>
        <p>Under the Diagnostics tab, go to Component | Infotainment Head Unit (IHU) | Parameters to view the part
          number for the voice files (Speech DB Part Number). This will let you know if the voice files need to be
          updated.</p>
        <p>Under the Diagnostics tab, go to Service Functions|12V Power Overview. Check that you have “Green Lights”
          next to SoC and Battery Current. Check that the Main Battery and Support Battery should show above 12V before
          continuing.</p>
        <p>Complete the SWDL in the Software tab. Refresh the Upgrade list to ensure there are no other updates
          available.</p>
        <p>When the SWDL finishes, complete a function test of the vehicle. Update maps, voice, GraceNote, and apps if
          necessary.</p>
        <p>Reset any customer settings that changed during the SWDL.</p>
        <p><strong>Before getting out of the vehicle.</strong></p>
        <ol>
          <li>Take a picture of the installed apps</li>
          <li>Check the map version</li>
          <li>Set the lights to the ‘Position’ setting</li>
        </ol>
        <p><strong>On exit of the vehicle</strong></p>
        <ol>
          <li>Open the tailgate/bootlid</li>
          <li>Open the hood</li>
          <li>Leave the driver’s door open</li>
          <li>Connect the maintainer</li>
          <li>Check the maintainer voltage output (13-15 V)</li>
          <li>Connect VIDA</li>
        </ol>
        <p><strong>After connecting VIDA</strong></p>
        <ol>
          <li>Go to Diagnostics | Service Functions | 12V Power Overview</li>
          <li>Check that the SoC and Current parameters have a green light. If they are not green, repair the issue
            before proceeding.
          </li>
          <li>Go to the Software tab and begin the process for loading the appropriate software.</li>
          <li>Check for updates after the download finishes.</li>
          <li>Disconnect the vehicle from VIDA.</li>
        </ol>
        <p><strong>After the SWDL completes.</strong></p>
        <ol>
          <li>Reset all the changes made before download.</li>
          <li>Check that the apps are still present. Reload apps if necessary.</li>
          <li>Check that there are no app updates available. Update apps if necessary.</li>
          <li>Update the navigation map, voice, and GraceNote files if necessary.</li>
          <li>Move the vehicle outside and perform an INRIX test and ensure the Weather app works correctly. Repair if
            necessary.
          </li>
        </ol>
        <p><strong>SWDL Recovery</strong></p>
        <p><strong>This is a general guide with tips and tricks to help recover a vehicle in the event of a software
          download failure.</strong></p>
        <p>Here are a couple of steps to follow.</p>
        <p>The following concerns vehicles that are offline after the SWDL failure:</p>
        <p>Rectify issues and reattempt according to the SWDL job aid.</p>
        <p>Why did the download fail? VIDA error, Network problem, timeout error, battery voltage error, etc.</p>
        <p>Correct the failure issue before attempting another SWDL.</p>
        <p>Disconnect the VOE and perform a battery reset.</p>
        <p>If the main or support battery voltage is too low, charge the weak battery while it is disconnected for the
          reset.</p>
        <p>Restart VIDA during the battery reset.</p>
        <p>If the vehicle has recovered after the reset, start the vehicle and let it run for approximately 5
          minutes.</p>
        <p>Perform a <strong>NEW</strong> VIDA readout, clear all DTCs, and open the 12V overview in Service functions.
          Is the SoC above 70%?</p>
        <p>If yes, then check the PIE server connection by navigating to Software | Advanced Test | Test PIE
          connection.</p>
        <p>If the PIE connection passes, use the advanced test to “ping” the VCM and IHU.</p>
        <p>Attempt the “Configuration test” software. This is a small software that will verify the ability to complete
          a SWDL.</p>
        <p>If the failure occurred during a total upgrade, service 2.0, or PDS SWDL, reattempt to download the desired
          software.</p>
        <p>If the failure occurred during a total upgrade, service 2.0, or PDS SWDL and the reattempt failed, attempt to
          reload the failed module separately. For example, the SWDL fails during the IHU loading. Reload the IHU, then
          reattempt the total upgrade.</p>
        <p>The following concerns vehicles that are online after the SWDL failure:</p>
        <p>Rectify issues and reattempt according to the SWDL job aid.</p>
        <p>Why did the download fail? VIDA error, Network problem, timeout error, battery voltage error, etc.</p>
        <p>If possible, correct the failure issue before attempting another SWDL.</p>
        <p>Start the vehicle and allow it to run for approximately 5 minutes.</p>
        <p>While the vehicle is running, check the PIE server connection by navigating to Software | Advanced Test |
          Test PIE connection.</p>
        <p>If the failure occurred during a total upgrade, service 2.0, or PDS SWDL, attempt to reload the failed module
          separately. For example, if the SWDL fails during the IHU loading, then reload the IHU and reattempt the total
          upgrade.</p>
        <p>The objective of this job aid is to give technicians the tools and instructions to accurately and efficiently
          complete a software download to SPA and CMA vehicles.</p>
        <p>Job aids are meant to be an additional source of information. VIDA and TIE should always be consulted for the
          latest test methods and repair procedures.</p>
      </VidaSection>
    </VidaSection>
  </div>
}

export default SoftwareDownload;
